import type { PropsWithChildren } from "react";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { createGlobalStyle } from "styled-components";

import { useServiceContext } from "@/services";
import { Theme } from "@/services/monday";

const ThemeContext = createContext<Theme>(Theme.LIGHT);

export function WithMondayTheme({ children }: PropsWithChildren) {
  const { monday } = useServiceContext();
  const [theme, setTheme] = useState<Theme>(Theme.LIGHT);
  const prevTheme = useRef<Theme>();

  useEffect(() => {
    return monday.listenToBoardContext((data) => {
      setTheme(data.theme);
      if (prevTheme.current) {
        document.body.classList.remove(`${prevTheme.current}-app-theme`);
      }
      document.body.classList.add(`${data.theme}-app-theme`);
      prevTheme.current = data.theme;
    });
  }, [monday]);

  return (
    <>
      <BodyGlobalStyle />
      <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
    </>
  );
}

export function useMondayTheme() {
  return useContext(ThemeContext);
}

const BodyGlobalStyle = createGlobalStyle`
  body {
    color: var(--primary-text-color);
    font-family: var(--font-family);
  }

  .monday-style-dialog-content-wrapper {
    z-index:2;
  }

  .hacker_theme-app-theme *:not(.fa):not([class^="re-icon-"],[class*=" re-icon-"]) {
    font-family: menlo, monospace !important;
}
`;
